import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Odysseus admin module — `/odysseus*` on console.francisquini.ai.
 *
 * Routes:
 *   - `/odysseus` — overview for the autonomous user-journey testing
 *     platform (T9.7 baseline).
 *   - `/odysseus/onboarding` — Peitho onboarding funnel console (T10
 *     Frente E.1). Lists journeys, surfaces stuck users by step, and
 *     fires admin actions (jump_to_step + nudge, abandon).
 *
 * RequireAdmin gate sits inside each page component itself; the
 * `surface: 'admin'` field ensures the routes are not even mounted on
 * the Cuidari host (defence-in-depth).
 */
export const manifest: ModuleManifest = {
  module_id: 'odysseus',
  display_name: 'Odysseus',
  surface: 'admin',
  routes: [
    {
      path: '/odysseus',
      component: () =>
        import('@/routes/_app/odysseus').then((m) => ({
          default: m.OdysseusOverviewPage,
        })),
      title: 'Odysseus',
      permissions: [],
    },
    {
      path: '/odysseus/onboarding',
      component: () =>
        import('@/routes/_app/odysseus/onboarding').then((m) => ({
          default: m.OdysseusOnboardingPage,
        })),
      title: 'Odysseus — Onboarding',
      permissions: [],
    },
  ],
}
